import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService, Provider, ProviderTitle } from '@docpath/linces-angular-components/common';
import { DpLoginInfo } from '@docpath/webcomponents';
import { RoutingPath } from 'src/app/constants/routing-path';
import { AppService } from 'src/app/shared/services/app.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {

  error!: string;
  hasError!: boolean;
  hasOtherLoginError!: boolean;
  loginInfo!: { username: string, password: string; };
  pattern!: string;
  providersData: Provider[] = [];
  providersTitle: { [key: string]: string; } = {
    'okta': ProviderTitle.Okta
  };
  providers: string[] = [];

  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router,
    private readonly appService: AppService
  ) {}

  ngOnInit(): void {
    this.error = '';
    this.hasError = false;
    this.hasOtherLoginError = false;
    this.loginInfo = { username: '', password: '' };
    this.pattern = '^\\S.*$';
    this.getProviders();
  }

  doLogin(loginEvent: DpLoginInfo) {
    this.loginInfo.username = loginEvent.user;
    this.loginInfo.password = loginEvent.password;
    this.login();
  }

  getProviders() {
    this.loginService.getProviders({
      catchError: () => {
        this.providers = [];
      },
      suscribe: response => {
        this.providersData = response.result as unknown as Provider[];

        this.providers = [];
        this.providersData.forEach(provider => {
          if (this.providersTitle[provider.type]) {
            this.providers.push(this.providersTitle[provider.type]);
          }
        });
      }
    });
  }

  otherLoginMethod(method: string) {
    this.hasOtherLoginError = false;
    if (method === ProviderTitle.Okta) {
      this.loginWithOkta();
    }
  }

  loginWithOkta() {
    const oktaProvider = this.providersData.find(provider => provider.type === 'okta');

    if (oktaProvider) {
      this.loginService.getOktaToken({
        catchError: (statusCode, message) => {
          this.manageOktaError(message);
        },
        suscribe: () => {
          this.router.navigate([ RoutingPath.PATH_HOME ]);
        }
      }, oktaProvider, environment.CONTEXT, environment.CONTEXT);
    }
  }

  manageOktaError(message: string) {
    if (message !== '') {
      this.hasOtherLoginError = true;
      this.error = message;
    }
  }

  private login() {
    this.loginService.login({
      queryParameters: { username: this.loginInfo.username, pass: this.loginInfo.password },
      catchError: (statusCode, message) => this.processError(message),
      suscribe: () => {
        this.appService.notifyUserLogged(true);
        this.router.navigate([ RoutingPath.PATH_HOME ]);
      }
    });
  }

  processError(message: string): void {
    this.hasError = true;
    this.error = message;
  }

}
